module.exports = __webpack_public_path__ + "assets/img/2b435062c26a90a3b600ab79d1fb3f8c.svg";